import React from 'react'
import team from '../../assets/team.png'

const Introbanner = () => {
  return (
    <div className="h-[340px] w-full mt-24">
          <div className=" text-prime font-semibold text-2xl font-[Montserrat] mt-40 ml-20">About Us</div>
          <div className="flex flex-col-2 justify-between">
              <div className="flex flex-col pl-20">
                    <div className="text-5xl font-bold font-[Montserrat] mt-5">
                        We're product builders 
                    </div>
                  <div className="mt-5 font-prime text-warp w-[54%]">
                      We're a team mix of diverse languages, cultures, and varied professional experiences. We use all of our cumulative backgrounds to imagine new product experiences and solve complex problems.
                  </div>
              </div>
              <div className="pr-80 w-[1400px]">
                  <img src={team} alt="" />
              </div>
          </div>
    </div>
  )
}

export default Introbanner